import { $, $$, sliderConfig } from '@utils';
import Swiper from 'swiper';
import { Navigation, Scrollbar, A11y, FreeMode } from 'swiper/modules';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-news-categories]')) return;

  buildSlider();
  newsCategoriesDatalayer();
}

function buildSlider() {
  $$('[data-au-news-categories-slider]').forEach((slider) => {
    new Swiper(slider, {
      modules: [Navigation, Scrollbar, A11y, FreeMode],
      ...sliderConfig,
      slidesPerView: 1.5,
      spaceBetween: 8,
      breakpoints: {
        560: {
          slidesPerView: 2.2,
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 3.2,
          spaceBetween: 8,
        },
        1024: {
          slidesPerView: 4.2,
          spaceBetween: 8,
        },
        1280: {
          slidesPerView: 5,
          spaceBetween: 16,
        },
      },
    });
  });
}

function newsCategoriesDatalayer() {
  $$('[data-au-news-categories-slide]').forEach((slide) => {
    slide.addEventListener('click', (e) => {
      const el = e.currentTarget;
      const titleText = el.closest('[data-au-news-categories]').querySelector('[data-au-title]')
        ? `${el.closest('[data-au-news-categories]').querySelector('[data-au-title]').innerText}_`
        : '';
      const clickText = el.querySelector(':not([data-au-icon])').innerText;
      const item_id = `${removeAccentMarkAndUppercase(titleText)}${removeAccentMarkAndUppercase(clickText)}`;

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickBoton',
        item_id,
      });
    });
  });
}

export default { init };
